import { PORTALS_WITH_OPTIONS } from '../constants'

export const validateAdSelectedOptions = (
  selectedPortals: string[],
  selectedAdOptions: {
    portalId: string
    adOptionId: string
    name: string
    available?: number
  }[]
): boolean => {
  const portalsWithAds = selectedPortals?.filter((portal) => {
    return PORTALS_WITH_OPTIONS?.includes(portal)
  })

  const missingAds = portalsWithAds?.some(
    (portal) =>
      !selectedAdOptions?.some((option) => option?.portalId === portal)
  )

  return missingAds
}
